var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    {
      staticClass: "k-sort-filter-menu k-number-filter-menu",
      attrs: { subheader: "" }
    },
    [
      _vm.sortable
        ? _c(
            "div",
            [
              _c("v-subheader", [_vm._v("Sorting:")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      class: _vm.sort.asc,
                      attrs: { flat: "", color: "info" },
                      on: {
                        mousedown: function($event) {
                          return _vm.handleSortClick("asc")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "k-sort-icon-container" },
                            [
                              _vm._v("\n            0-9\n            "),
                              _c("v-icon", [_vm._v("straight")])
                            ],
                            1
                          ),
                          _vm._v("\n          Ascending\n        ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "k-operation-check-icon",
                          attrs: { color: "info" }
                        },
                        [_vm._v("check")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      class: _vm.sort.desc,
                      attrs: { flat: "", color: "info" },
                      on: {
                        mousedown: function($event) {
                          return _vm.handleSortClick("desc")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "k-sort-icon-container" },
                            [
                              _vm._v("\n            9-0\n            "),
                              _c("v-icon", { staticClass: "inverted" }, [
                                _vm._v("straight")
                              ])
                            ],
                            1
                          ),
                          _vm._v("\n          Descending\n        ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "k-operation-check-icon",
                          attrs: { color: "info" }
                        },
                        [_vm._v("check")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-subheader", [_vm._v("Filter:")]),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("span", { attrs: { "data-options": "filter" } }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.eq,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Equal to", "eq")
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("=")
                  ]),
                  _vm._v("\n          Equal to\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.neq,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Not equal to", "neq")
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("≠")
                  ]),
                  _vm._v("\n          Not equal to\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.gte,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick(
                      "Greater than or equal to",
                      "gte"
                    )
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("≥")
                  ]),
                  _vm._v("\n          Greater than or equal to\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.gt,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Greater than", "gt")
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v(">")
                  ]),
                  _vm._v("\n          Greater than\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.lte,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick(
                      "Less than or equal to",
                      "lte"
                    )
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("≤")
                  ]),
                  _vm._v("\n          Less than or equal to\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.operator.lt,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleOperatorClick("Less than", "lt")
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("<")
                  ]),
                  _vm._v("\n          Less than\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.empty.isnull,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleEmptyClick("Null", "isnull")
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("∅")
                  ]),
                  _vm._v("\n          Null\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                class: _vm.empty.isnotnull,
                attrs: { flat: "", color: "info" },
                on: {
                  mousedown: function($event) {
                    return _vm.handleEmptyClick("Not null", "isnotnull")
                  }
                }
              },
              [
                _c("span", [
                  _c("span", { staticClass: "k-filter-item-symbol" }, [
                    _vm._v("≠∅")
                  ]),
                  _vm._v("\n          Not null\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "k-operation-check-icon",
                    attrs: { color: "info" }
                  },
                  [_vm._v("check")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-btn",
            {
              class: _vm.operator.between,
              attrs: { flat: "", color: "info" },
              on: {
                mousedown: function($event) {
                  return _vm.handleOperatorClick("Between", "between")
                }
              }
            },
            [
              _c("span", [
                _c(
                  "span",
                  {
                    staticClass: "k-filter-item-symbol",
                    staticStyle: { "font-size": "8px" }
                  },
                  [_vm._v("\n          [a,b]\n        ")]
                ),
                _vm._v("\n        Between\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-icon",
                {
                  staticClass: "k-operation-check-icon",
                  attrs: { color: "info" }
                },
                [_vm._v("check")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", {
        staticStyle: { "margin-top": "4px", "margin-bottom": "2px" }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }